// The tree page the button opens. The consumer table lists the tree's members, so it shows
// the consumer. The tree pages cannot select a node from the URL, so none is selected.
export const TREE_PAGE = 'AnalyticsConsumerTable'

export const NO_CONSUMER_HINT = 'בחרו צרכן מהרשימה כדי לעבור לעץ המים שלו'
export const NO_TREE_HINT = 'הצרכן אינו שייך לאף עץ מים'
export const NO_SUPPLIED_TREE_HINT = 'המד אינו ספק של אף עץ מים'
export const TREE_FAILED_HINT = 'עץ המים לא נטען. נסו שוב'

export type TreeButtonState =
  | { status: 'no-consumer' }
  | { status: 'loading' }
  | { status: 'failed' }
  | { status: 'none' }
  | { status: 'found'; treeId: number }

// The Gateway sends each consumer one parentId: the hierarchy group where the meter is a
// consumer, a root group first. A meter that only supplies or passes water on has none.
export const treeStateOfParent = (
  parentId: number | null | undefined
): TreeButtonState =>
  parentId != null ? { status: 'found', treeId: parentId } : { status: 'none' }

/** The trees one meter belongs to: the one it consumes from and the one it supplies. */
export type MeterTrees = {
  parent: TreeButtonState
  supplier: TreeButtonState
}

export const treesOfConsumer = (consumer: {
  parentId?: number | null
  supplierOfId?: number | null
}): MeterTrees => ({
  parent: treeStateOfParent(consumer.parentId),
  supplier: treeStateOfParent(consumer.supplierOfId),
})

export const waterTreePath = (siteId: string, treeId: number) =>
  `/${siteId}/analytics/tree/${treeId}/${TREE_PAGE}`

/** Why the button is disabled, or null when it can open a tree. */
export const treeButtonHint = (
  state: TreeButtonState,
  noTreeHint: string = NO_TREE_HINT
): string | null => {
  switch (state.status) {
    case 'found':
      return null
    case 'no-consumer':
      return NO_CONSUMER_HINT
    case 'none':
      return noTreeHint
    case 'failed':
      return TREE_FAILED_HINT
    case 'loading':
      return ''
  }
}
